import LegalLayout, { LegalSection } from "@/components/landing/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      intro="Last updated: August 2026 — how Revanta Asset Management collects, uses, and protects your personal information."
      testId="privacy-page"
    >
      <LegalSection title="1. Who we are">
        <p>
          Revanta Asset Management ("we", "us", "our") provides IT asset disposition and e-waste
          recycling services across Australia. This policy explains how we handle
          personal information in accordance with the Privacy Act 1988 (Cth) and the Australian
          Privacy Principles.
        </p>
      </LegalSection>

      <LegalSection title="2. What we collect">
        <p>When you submit a booking or contact us, we collect:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Your full name and company name</li>
          <li>Email address and phone number</li>
          <li>Estimated volume and a description of the equipment to be collected</li>
          <li>Any correspondence you send us</li>
        </ul>
        <p>
          We also collect basic technical information (such as browser type and pages visited) to
          keep the site secure and improve it.
        </p>
      </LegalSection>

      <LegalSection title="3. How we use your information">
        <p>We use the information we collect to:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Respond to your enquiry and arrange your e-waste collection</li>
          <li>Prepare quotes, recycling reports, and Certificates of Data Destruction</li>
          <li>Meet our legal, accounting, and compliance obligations</li>
          <li>Improve our website and services</li>
        </ul>
        <p>We will not send you marketing communications without your consent.</p>
      </LegalSection>

      <LegalSection title="4. Who we share it with">
        <p>
          We share your details only with the certified logistics and downstream recycling
          partners involved in fulfilling your collection, and only to the extent needed. We never
          sell your personal information.
        </p>
      </LegalSection>

      <LegalSection title="5. Data security">
        <p>
          We apply appropriate technical and organisational measures to protect your information.
          Data-bearing devices collected through our service are sanitised or physically destroyed
          in line with our certified data destruction process.
        </p>
      </LegalSection>

      <LegalSection title="6. Retention">
        <p>
          We keep personal information only for as long as needed to provide our services and meet
          legal obligations, after which it is securely destroyed or de-identified.
        </p>
      </LegalSection>

      <LegalSection title="7. Access and correction">
        <p>
          You may request access to, or correction of, the personal information we hold about you
          at any time by emailing karan@revantaassetmanagement.com. We will respond within a
          reasonable timeframe.
        </p>
      </LegalSection>

      <LegalSection title="8. Changes to this policy">
        <p>
          We may update this policy from time to time. The current version is always published on
          this page with its revision date.
        </p>
      </LegalSection>

      <LegalSection title="9. Contact us">
        <p>
          Questions or complaints about privacy? Contact us at karan@revantaassetmanagement.com or
          +61 466 426 343. If you are not satisfied with our response, you may contact the Office
          of the Australian Information Commissioner.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
